import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "_flex _jc-sb" }
const _hoisted_2 = { class: "_flex _gap-2 _pos-r _w-100" }
const _hoisted_3 = { class: "_flexcol _gap-1 _w-100" }
const _hoisted_4 = { class: "_flexcol _gap-3" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_image = _resolveComponent("skeleton-image")
  const _component_skeleton_line = _resolveComponent("skeleton-line")
  const _component_box = _resolveComponent("box")
  const _component_skeleton_wrapper = _resolveComponent("skeleton-wrapper")

  return (_openBlock(), _createBlock(_component_skeleton_wrapper, { class: "_flexcol _gap-2" }, {
    default: _withCtx(() => [
      _createVNode(_component_box, { class: "_flexcol _gap-3" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_skeleton_image, { size: 42 }),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_skeleton_line, {
                  height: 18,
                  "width-percent": 30
                }),
                _createVNode(_component_skeleton_line, {
                  height: 18,
                  "width-percent": 45
                })
              ])
            ]),
            _createVNode(_component_skeleton_line, {
              height: 18,
              "width-percent": 15
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_skeleton_line, {
              height: 22,
              "width-percent": 50
            }),
            _createVNode(_component_skeleton_line, {
              height: 22,
              "width-percent": 25
            })
          ])
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }))
}